// extracted by mini-css-extract-plugin
export var active = "_ly-2";
export var recordingDot = "_ly-1";
export var recordingIndicator = "_ly-0";